import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetCtCategoryCacheApi } from '@/apis/ct_categorys/category.api';

const { wsCache } = useCache();
const CacheKey = `CategoryCache`;

export const useCtCategory = defineStore('Ct_Category_Store', {
	state: (): any => ({
		categoryList: [] as any[],
		categoryMap: {} as any,
	}),
	actions: {
		getName(categoryId: string) {
			if (!categoryId) return '--';
			return this.categoryMap.get(categoryId) ?? '--';
		},
		getNameByCode(categoryCode: string) {
			if (!categoryCode) return '--';
			return this.categoryMap.get(categoryCode) ?? '--';
		},
		/* 合同分类列表：Tree */
		getTreeList() {
			const genCategoryTree = (dataList: any[]) => {
				const selectList = [] as any[];

				dataList.forEach((ca: any) => {
					const childrens = this.categoryList.filter((d: any) => d.parent_id == ca.id) ?? [];
					const item = {
						label: ca.name,
						value: ca.id,
						level: ca.level,
						children: [] as any[],
					};
					item.children = genCategoryTree(childrens);
					selectList.push(item);
				});

				return selectList;
			};

			const parentList = this.categoryList.filter((ca: any) => ca.is_enabled == 'Y' && ca.parent_id == '10000000-0000-0000-0000-000000000001');
			const categorys = genCategoryTree(parentList || []);

			return categorys.filter((ca: any) => (ca.children || []).length > 0) ?? [];
		},

		/* 组装数据字典 */
		async setDataMap() {
			let dataList = wsCache.get(CacheKey);
			if (!dataList) {
				dataList = await this.setData();
			}

			/* 组装Map，格式：group_code|value */
			this.categoryMap = new Map();
			dataList.forEach((item: any) => {
				this.categoryMap.set(`${item.id}`, item.name);
				this.categoryMap.set(`${item.code}`, item.name);
			});

			this.categoryList = dataList;
		},
		/* 从接口获取数据 */
		setData() {
			return new Promise((resolve) => {
				GetCtCategoryCacheApi().then((res: any) => {
					const { succeeded, errors, data } = res;
					if (!succeeded) {
						resolve([]);
					} else {
						wsCache.set(CacheKey, data || []);
						resolve(data || []);
					}
				});
			});
		},
	},
});
